import React from 'react';
import '../less/public_contracts.less';
import FilesForDownloadNew from '../../../auxiliary-components/shared/FilesForDownloadNew';
import { getSafeLinkProps } from './../../../helpers/utils/urlSecurity';

export default function template() {

    return (
      <div className="public-contacts">
        <FilesForDownloadNew
          widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
          loader={this.state.loader}
          titleTag={"h1"}
        />
        <div className="public-contacts__terms terms">
          <div className="container">
            <div className="terms_body">
              <h2 className="terms__title">{this.l10n("PUBLIC_CONTRACTS_TEXT")}</h2>
              <a
                className="terms__btn"
                {...getSafeLinkProps('/terms', {target: "_self"})}
              >
                {this.l10n("PUBLIC_CONTRACTS_BTN")}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
}
